const configuredApi = import.meta.env.VITE_API_BASE_URL?.trim();
const API = import.meta.env.DEV && configuredApi ? configuredApi : "";

export async function api<T>(path: string, init: RequestInit = {}, token?: string): Promise<T> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 15_000);

  try {
    const res = await fetch(`${API}${path}`, {
      ...init,
      cache: "no-store",
      signal: init.signal ?? controller.signal,
      headers: {
        "content-type": "application/json",
        ...(token ? { authorization: `Bearer ${token}` } : {}),
        ...(init.headers || {}),
      },
      credentials: "include",
    });

    const body = await res.json();
    if (!res.ok) throw new Error(body.error?.message || "Request failed");
    return body.data as T;
  } catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") {
      throw new Error("The request timed out. Check your connection and try again.");
    }
    if (error instanceof TypeError) {
      throw new Error("Unable to reach Audiograph OS. Refresh the page or check your browser connection.");
    }
    throw error;
  } finally {
    window.clearTimeout(timeout);
  }
}
